let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ugri")).then(() => parcelRequire('iGGJZ'));